__turbopack_context__.v({
  "className": "inter_5abb76df-module___me5ba__className",
});
